export default __webpack_public_path__ + "static/media/bitcoinBlack.def1ccdf.svg";